import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import { CapturedImageWrapperStyled as WrapperStyled } from '../CheckDepositSubmissionOverview.styles';

const SummaryDetails = ({ title, value }) => (
  <WrapperStyled>
    <Text size="md">{title}</Text>
    <Text
      size="md"
      weight="medium"
    >
      {value}
    </Text>
  </WrapperStyled>
);

SummaryDetails.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired
};

export default SummaryDetails;
